//import Api from '@/api/Api';
import uploadWithAuth from "@/api/ApiUpload";
import errorHandler from "@/utils/plugins/ErrorHandler";
import Api from "../Api";

const RESOURCE_FUEL_RECEIPT_MEDIA_OBJECT = "/fuel_receipt_media_objects";

export default {
  upload() {},
  uploadDocumentFile(file, cost, vehicleRequest) {
    let formData = new FormData();
    formData.append("file", file);
    formData.append("cost", cost);
    formData.append("vehicleRequest", vehicleRequest);

    return uploadWithAuth({
      method: "post",
      url: process.env.VUE_APP_API_URI + RESOURCE_FUEL_RECEIPT_MEDIA_OBJECT,
      data: formData,
      headers: {
        "Content-Type": "multipart/form-data",
        Accept: "application/ld+json",
      },
      errorHandle: false,
    });
  },
  getFuelReceiptMediaObject(id) {
    return Api().get(
      process.env.VUE_APP_API_URI +
        RESOURCE_FUEL_RECEIPT_MEDIA_OBJECT +
        "/" +
        id
    );
  },
  deleteFuelReceiptMediaObject(id) {
    return uploadWithAuth({
      method: "delete",
      url:
        process.env.VUE_APP_API_URI +
        RESOURCE_FUEL_RECEIPT_MEDIA_OBJECT +
        `/${id}`,
    }).catch((err) => errorHandler(err, null));
  },
};
